import React from 'react';
import styles from './Chip.module.css';

export interface ChipProps {
    label: string;
    onClick?: () => void;
    disabled?: boolean;
    variant?: 'default' | 'active';
}

export default function Chip({
    label,
    onClick,
    disabled = false,
    variant = 'default',
}: ChipProps) {
    return (
        <button
            type="button"
            className={`${styles.chip} ${styles[variant]} ${disabled ? styles.disabled : ''}`}
            onClick={!disabled ? onClick : undefined}
            disabled={disabled}
        >
            <span className={styles.label}>{label}</span>
        </button>
    );
}

